// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ebd96073","455":"8bf1539f","670":"a37ce975","977":"403b46f5"}[chunkId] + ".chunk.js";
};